// "Off course" clock on the 404 race bib.
//
//   <span data-off-course-clock>00:00</span>
//
// Counts the time since the page loaded, mm:ss (h:mm:ss past the hour).
// The bib is aria-hidden, so the tick never reaches a screen reader.

function format(total) {
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const pad = (n) => String(n).padStart(2, "0");
    return h ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

export default function offCourse() {
    const clock = document.querySelector("[data-off-course-clock]");
    if (!clock) return;

    const start = Date.now();
    const tick = () => {
        clock.textContent = format(Math.floor((Date.now() - start) / 1000));
    };
    setInterval(tick, 1000);
}
